import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'
import { EMPTY } from '@/lib/customer-format'
import type { CustomerUser } from '@/lib/customer-types'

export function CustomerUsers({ users }: { users: CustomerUser[] }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Users · {users.length}</CardTitle>
      </CardHeader>
      <CardContent>
        {users.length === 0 ? (
          <p className="text-sm text-cmd-outline">No staff users on this account.</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <thead>
                <tr className="border-b border-cmd-highest text-left font-label text-[0.65rem] uppercase tracking-wider text-cmd-outline">
                  <th className="py-2 pr-4">Name</th>
                  <th className="py-2 pr-4">Email</th>
                  <th className="py-2 pr-4">Role</th>
                  <th className="py-2">Status</th>
                </tr>
              </thead>
              <tbody>
                {users.map((u, i) => (
                  <tr
                    key={`${u.email ?? u.name ?? 'user'}-${i}`}
                    className={`border-b border-cmd-highest/50 ${
                      i % 2 === 0 ? 'bg-cmd-surface' : 'bg-cmd-low'
                    }`}
                  >
                    <td className="py-2 pr-4 text-white/90">{u.name ?? EMPTY}</td>
                    <td className="py-2 pr-4 font-mono text-xs text-white/70">
                      {u.email ?? <span className="text-cmd-outline">{EMPTY}</span>}
                    </td>
                    <td className="py-2 pr-4 text-cmd-outline">{u.role}</td>
                    <td className="py-2">
                      <Badge variant={u.status === 'active' ? 'success' : 'secondary'}>
                        {u.status}
                      </Badge>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </CardContent>
    </Card>
  )
}
